<template>
  <div class="collision-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="canvas-box">
      <svg width="100%" height="250" viewBox="0 0 400 250">
        <line x1="20" y1="200" x2="380" y2="200" stroke="#333" stroke-width="2" />
        
        <!-- 球 A -->
        <g :transform="`translate(${p1.x}, 200)`">
          <circle r="20" fill="#ff4757" />
          <line x1="0" y1="0" :x2="p1.v * 5" y2="0" stroke="#fff" stroke-width="2" marker-end="url(#arr-w)" />
          <text y="-25" text-anchor="middle" fill="#ff4757">m1</text>
        </g>

        <!-- 球 B -->
        <g :transform="`translate(${p2.x}, 200)`">
          <circle r="20" fill="#00d2ff" />
          <line x1="0" y1="0" :x2="p2.v * 5" y2="0" stroke="#fff" stroke-width="2" marker-end="url(#arr-w)" />
          <text y="-25" text-anchor="middle" fill="#00d2ff">m2</text>
        </g>

        <defs>
          <marker id="arr-w" markerWidth="6" markerHeight="4" refX="6" refY="2" orient="auto">
            <polygon points="0 0, 6 2, 0 4" fill="#fff" />
          </marker>
        </defs>
      </svg>
    </div>

    <div class="calc-box">
       <div class="p-val">m1v1 + m2v2 = {{ momentum.toFixed(1) }} (动量恒定)</div>
       <div class="e-val" v-if="type === 'elastic'">机械能守恒</div>
       <div class="e-val" v-else>机械能损失最大</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollisionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      type: 'elastic',
      p1: { x: 50, v: 4 },
      p2: { x: 250, v: 0 },
      isMoving: false
    }
  },
  computed: {
    momentum() { return 1 * this.p1.v + 1 * this.p2.v; }
  },
  methods: {
    start() {
      if (this.isMoving) return;
      this.p1 = { x: 50, v: 4 };
      this.p2 = { x: 250, v: 0 };
      this.isMoving = true;
      this.animate();
    },
    animate() {
      if (!this.isMoving) return;
      
      this.p1.x += this.p1.v;
      this.p2.x += this.p2.v;

      // 碰撞检测
      if (this.p2.x - this.p1.x <= 40) {
        if (this.type === 'elastic') {
          // 简化的弹性碰撞 (等质量交换速度)
          const v1 = this.p1.v;
          const v2 = this.p2.v;
          this.p1.v = v2;
          this.p2.v = v1;
        } else {
          // 完全非弹性碰撞 (合二为一)
          const commonV = (this.p1.v + this.p2.v) / 2;
          this.p1.v = commonV;
          this.p2.v = commonV;
        }
        // 防止穿透
        this.p2.x = this.p1.x + 40.1;
      }

      if (this.p1.x > 400 || this.p2.x > 400 || this.p1.x < 0) {
        this.isMoving = false;
        return;
      }
      requestAnimationFrame(this.animate);
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
.collision-viz { width: 100%; color: #fff; display: flex; flex-direction: column; gap: 10px; }
.viz-header { display: flex; justify-content: space-between; padding: 10px; background: rgba(255,255,255,0.05); }
.canvas-box { background: #0a0a0a; border-radius: 8px; }
.calc-box { padding: 10px; background: rgba(46, 213, 115, 0.1); border-radius: 4px; font-size: 0.9rem; .p-val { color: #2ed573; font-weight: bold; } .e-val { font-size: 0.8rem; color: #888; } }
</style>
